import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=140c272e&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=140c272e&prod&lang=scss"
import style1 from "./GoodsDetail.vue?vue&type=style&index=1&id=140c272e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c272e",
  null
  
)

export default component.exports